<template>
  <div>
  <h1>This is Home!</h1>
  <button @click="addnum()">clicked {{ num }} times</button>
  </div>
</template>

<script>
// import {mapState, mapMutations} from 'vuex'
export default {
  name: 'Home',
  methods: {
    addnum () {
      this.$store.commit('addnum', 10)
    }
    // ...mapMutations(['addnum'])
  },
  computed: {
    num () {
      return this.$store.state.num
    }
    // ...mapState(['num'])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue